import React from 'react';

import FloodAlertIcon from './FloodAlertIcon.js';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import loadable from '@loadable/component';

import CentralLink from './CentralLink.js';

const SevereFloodWarningAdviceBox = loadable(() => import('./SevereFloodWarningAdviceBox.js'));
const AppPushEnableIcon = loadable(() => import('./AppPushEnableIcon'), { fallback: null, ssr: false });

function FloodAlertSummaryComponent({ severityLevel, areaName, fwisCode, button = true, className, enableFloodWarningAdvice = false, pushEnable, showPushEnableIcon }) {
	pushEnable = !!pushEnable;
	showPushEnableIcon = !!showPushEnableIcon;

	const severityText = {
		1: " Severe Flood Warning",
		2: " Flood Warning",
		3: " Flood Alert",
		4: " No Alert"
	}

	

	return <Row style={{ display: 'flex', alignItems: 'center' }}>
		{parseInt(severityLevel) === 1 && enableFloodWarningAdvice ? <Col xs={12}>
			 <SevereFloodWarningAdviceBox areaName={areaName}/>
		</Col> : [<Col key={"fasc-icon-"+fwisCode} xs={4}>
			<FloodAlertIcon severityLevel={severityLevel} style={{width: "80%", maxWidth: "157px"}} />
			{showPushEnableIcon ? <br /> : null}
			{showPushEnableIcon ? <AppPushEnableIcon pushEnable={pushEnable} /> : null}
			{!button && <span><br /><strong>{severityText[severityLevel]}</strong></span>}
		</Col>,
		<Col xs={8} key={"fasc-body-"+fwisCode} className={"align-middle" + " " + className} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
			<h4 className="hX-blendin header-bold">{areaName}</h4><br />
			{button && <CentralLink to={"/flood-alerts/" + fwisCode}>
				<Button variant="dark">View{severityText[severityLevel]}</Button>
			</CentralLink>}
		</Col>]}
	</Row>;
}

export default FloodAlertSummaryComponent;